"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _object = require("lodash/object");

var _getGoogleTag = _interopRequireDefault(require("./google/getGoogleTag"));

var _setUpGoogleAds = _interopRequireDefault(require("./google/setUpGoogleAds"));

var _adDisplayListeners = require("./adDisplayListeners");

var _getBidders = _interopRequireDefault(require("./getBidders"));

var _logger = _interopRequireDefault(require("./utils/logger"));

var _config = require("./config");

var _storage = require("./utils/storage");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
} // Set to true if we send a request to the ad server.
// If we ever make more than one fetch for ads on any page load,
// either make this more functional or remove module state entirely.


var adserverRequestSent = false;
/**
 * Add bidder targeting to googletag and send a request
 * to Google Ad Manager to fetch ads.
 * @return {undefined}
 */

function sendAdserverRequest() {
  // Return if the request to the adserver was already sent.
  if (adserverRequestSent === true) {
    return;
  }

  adserverRequestSent = true;

  _logger.default.debug("Ending auction."); // Set targeting and make a request to GAM.


  var googletag = (0, _getGoogleTag.default)();
  googletag.cmd.push(function () {
    var bidders = (0, _getBidders.default)(); // Set ad server targeting.

    bidders.forEach(function (bidder) {
      bidder.setTargeting();
    }); // Fetch ads.

    googletag.pubads().refresh();

    _logger.default.debug("Sent request to ad server."); // Mark which bidders returned bids in time to be included
    // in the ad server request.


    bidders.forEach(function (bidder) {
      var store = (0, _storage.getAdDataStore)(); // This is true if the bidder has returned bid responses.

      var bidsIncluded = !!(0, _object.get)(store, ['bidResponses', bidder.name, 'bidResponses'], null);

      if (bidsIncluded) {
        (0, _object.set)(store, ['bidResponses', bidder.name, 'includedInAdRequest'], true);
      }
    });
  });
}
/**
 * Initialize all bidders and make bid requests.
 * @return {undefined}
 */


var callBidders =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2(config) {
    var bidders;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _logger.default.debug("Loading all bidders in ads.js.");

            _context2.prev = 1;
            bidders = (0, _getBidders.default)();
            _context2.next = 5;
            return Promise.all(bidders.map(
            /*#__PURE__*/
            function () {
              var _ref2 = (0, _asyncToGenerator2.default)(
              /*#__PURE__*/
              _regenerator.default.mark(function _callee(bidder) {
                var bidResponseData, store;
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return bidder.fetchBids(config);

                      case 3:
                        bidResponseData = _context.sent;
                        store = (0, _storage.getAdDataStore)();
                        store.bidResponses[bidder.name] = _objectSpread(_objectSpread({}, bidResponseData), {}, {
                          // We set this to true during the ad server request if
                          // the bids returned in time.
                          includedInAdRequest: false
                        });
                        return _context.abrupt("return", bidResponseData);

                      case 9:
                        _context.prev = 9;
                        _context.t0 = _context["catch"](0);

                        _logger.default.error(_context.t0);

                        return _context.abrupt("return", null);

                      case 13:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 9]]);
              }));

              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 5:
            // If fetchBids returned for all the bidders, we can
            // call the ad server (if we haven't already).
            sendAdserverRequest();
            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);

            _logger.default.error(_context2.t0);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));

  return function callBidders(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchAds =
/*#__PURE__*/
function () {
  var _ref3 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee3(userConfig) {
    var config, adUnits;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            config = (0, _config.setConfig)(userConfig);
            _context3.prev = 1;

            if (config.disableAds) {
              _context3.next = 13;
              break;
            }

            adUnits = config.adUnits;

            if (adUnits.length) {
              _context3.next = 7;
              break;
            }

            _logger.default.debug('No ad units provided. Not setting up GAM or fetching bids.');

            return _context3.abrupt("return");

          case 7:
            // Define slots and enable ad services.
            (0, _setUpGoogleAds.default)(config); // Track loaded ads for analytics.

            (0, _adDisplayListeners.setUpAdDisplayListeners)(); // Call the ad server after some time to avoid waiting
            // too long for bid responses.

            setTimeout(function () {
              sendAdserverRequest();
            }, config.auctionTimeout);
            callBidders(config);
            _context3.next = 14;
            break;

          case 13:
            _logger.default.debug('Ads are disabled. Not setting up GAM or fetching bids.');

          case 14:
            _context3.next = 19;
            break;

          case 16:
            _context3.prev = 16;
            _context3.t0 = _context3["catch"](1);

            _logger.default.error(_context3.t0);

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 16]]);
  }));

  return function fetchAds(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var _default = fetchAds;
exports.default = _default;